'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var SelectList = require('@narvar/nth-select-list');
var index = require('../../../components/Language/index.js');
require('../../../components/Spinner/Spinner.module.css.js');
require('@babel/runtime/helpers/extends');
require('../../../components/LocationCard/LocationCard.js');
require('../../../components/PudoCard/PudoCard.js');
require('../../../components/ItemCard/ItemCard.js');
require('../../../components/SelectItem/SelectItem.js');
require('../../../components/SelectList/SelectList.js');
require('../../../components/ErrorBanner/ErrorBanner.js');
require('../../../components/Footer/Footer.js');
require('../../../components/StickyFooter/StickyFooter.js');
require('../../../components/SwatchesList/SwatchesList.js');
require('@narvar/nth-bit-text-link');
require('../../../components/Backdrop/Backdrop.module.css.js');
require('../../../components/LineItemsGroup/index.js');
require('../../../components/Skeleton/Skeleton.module.css.js');
var MultiLabels_module = require('./MultiLabels.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var SelectList__default = /*#__PURE__*/_interopDefaultLegacy(SelectList);

const MultiLabelsForm = _ref => {
  let {
    value,
    max = 5,
    onChange
  } = _ref;
  const ref = React.useRef(null);
  const handleChange = event => {
    onChange === null || onChange === void 0 ? void 0 : onChange(parseInt(event.target.value));
  };
  React.useEffect(() => {
    if (ref.current) {
      ref.current.focus();
    }
  }, []);
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: MultiLabels_module["default"].pudoElmWrap
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: MultiLabels_module["default"].wrapper,
    ref: ref,
    tabIndex: -1
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: MultiLabels_module["default"].header
  }, /*#__PURE__*/React__default["default"].createElement(index["default"], {
    langKey: "returnsPudoMultiLabelsTitle"
  })), /*#__PURE__*/React__default["default"].createElement("div", null, /*#__PURE__*/React__default["default"].createElement(index["default"], {
    langKey: "returnsPudoMultiLabelsDescription"
  })), /*#__PURE__*/React__default["default"].createElement(SelectList__default["default"], {
    className: MultiLabels_module["default"].selectList,
    onChange: handleChange,
    value: value
  }, /*#__PURE__*/React__default["default"].createElement(index["default"], {
    langKey: "returnsPudoMultiLabelsInputPlaceholder",
    tagName: "option",
    attributes: {
      value: 0
    }
  }), Array(max).fill(undefined).map((_, i) => {
    const value = i + 1;
    return /*#__PURE__*/React__default["default"].createElement("option", {
      key: value,
      value: value
    }, value);
  })), /*#__PURE__*/React__default["default"].createElement("div", null, /*#__PURE__*/React__default["default"].createElement(index["default"], {
    langKey: "returnsPudoMultiLabelsRemarks"
  }))));
};

exports["default"] = MultiLabelsForm;
